import $ from 'jquery'

$('.js-training-date').on('click', function () {
    $(this).submit();
});